module.exports = __webpack_public_path__ + "assets/img/office-building-budapart-1280.58793558.webp";